<template>
  <div class="createdActivityShow">
    <div class="createdActivityShow-img">
      <img src="@/assets/partyreports/top-bg-cjhdfc.png" alt />
    </div>
    <div class="createdActivityShow-box">
      <div>请填写活动风采相关信息</div>
      <p>
        <span style="color: red">*</span>
        活动标题
      </p>
      <el-input
        resize="none"
        type="text"
        v-model="texts.headline"
        placeholder="请输入"
      ></el-input>
      <p>
        <span style="color: red">*</span>
        活动详情描述
      </p>
      <Uedior />
      <div class="submit" @click="submit">确认提交</div>
    </div>

    <!-- 提交成功 -->
    <el-dialog :visible.sync="submitVisible" class="dialog">
      <div class="dialog-imgbox">
        <img src="@/assets/partyreports/tc-icon.png" alt="" />
        <div class="dialog-title">
          <p>活动风采创建成功!</p>
          <p>您可以在首页活动风采中查看</p>
        </div>
        <div class="buttonbox">
          <div class="Continue" @click="Continue">继续创建</div>
          <div class="button" @click="back">返回上级</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uedior from "@/views/component/Uedior";
export default {
  data() {
    return {
      texts: { msg: "", headline: "" },
      submitVisible: false,
    };
  },
  methods: {
    submit() {
      for (let key in this.texts) {
        if (this.texts[key] == "") {
          this.$message({
            message: "请填写完整",
            type: "error",
            offset: 300,
          });
          return false;
        }
      }
      let params = {
        headline: this.texts.headline,
        memo: this.texts.msg,
        userid: parseInt(sessionStorage.getItem('c2userid')),
      };
      this.axios
        .post("/api/ManageVolunteer/AddActivityStyle", params)
        .then((res) => {
          // if (res.data.code == 0) {
            this.submitVisible = true;
            for(let key in this.texts){
              this.texts[key] = ""
            }
          // }
        });
    },
    Continue() {
      this.submitVisible = false;
    },
    back() {
      window.history.back(-1);
    },
  },
  components: {
    Uedior,
  },
};
</script>

<style lang="scss" scoped>
.createdActivityShow {
  &-img {
    img {
      width: 100%;
    }
  }
  &-box {
    > div:first-child {
      font-size: 0.4rem;
      font-weight: bold;
      color: #000000;
    }
    p {
      font-size: 0.26rem;
      font-weight: 500;
      color: #666666;
      margin: 0.4rem 0 0.2rem;
    }
    .submit {
      width: 4.6rem;
      height: 0.76rem;
      background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
      box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
      border-radius: 0.08rem;
      font-weight: 500;
      color: #f6f5f8;
      line-height: 0.76rem;
      text-align: center;
      margin: 1rem auto 0;
    }
    .uploadBox {
      margin: 0 0 0.55rem;
    }

    width: 94%;
    left: 3%;
    padding: 0.4rem;
    padding-left: 0.2rem;
    background: #fff;
    position: absolute;
    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    top: 3.4rem;
    border-radius: 0.1rem;
  }
  .dialog {
    &-imgbox {
      img {
        width: 1.74rem;
        height: 1.74rem;
        border-radius: 50%;
      }
    }
    &-title {
      > p:nth-of-type(1) {
        font-size: 0.26rem;
        font-weight: 500;
        color: #666666;
        margin-bottom: 0.1rem;
      }
      > p:nth-of-type(2) {
        font-size: 0.3rem;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.3rem;
      }
    }
    .buttonbox {
      .Continue {
        width: 1.78rem;
        height: 0.76rem;
        border: 0.01rem solid #fd7651;
        border-radius: 0.08rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: 500;
        color: #fb7259;
        line-height: 0.76rem;
      }
      .button {
        width: 1.78rem;
        height: 0.76rem;
        background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
        border-radius: 0.08rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: 500;
        color: #f6f5f8;
        line-height: 0.76rem;
      }
      display: flex;
      justify-content: space-between;
    }
    // padding-bottom: 0.71rem;
  }
  /deep/.el-input__inner {
    background-color: #f4f4f4;
    border: none;
  }
  /deep/.el-textarea__inner {
    border: none;
    background-color: #f4f4f4;
    height: 7rem;
    color: black;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 2rem;
    height: 2rem;
    margin: 0 0.12rem 0.08rem 0;
  }
  /deep/.el-upload--picture-card {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
  }
  /deep/.el-dialog {
    width: 70%;
    text-align: center;
  }
  padding: 1rem 0 0;
  font-size: 0.3rem;
}
</style>